export const HISTORY_ENDPOINTS = {
  ADMIN: {
    MEMO: (historyId: number) =>
      `/api/v2/admin/histories/${historyId}/memo`,

    USER_POINTS: (userId: string) =>
      `/api/v2/admin/users/${userId}/histories/points`,

    USER_SCORES: (userId: string) =>
      `/api/v2/admin/users/${userId}/histories/scores`,
  },

  USER: {
    ME: '/api/v2/history/me',
  },

  SUPERADMIN: {
    TODAY_VISITORS:
      '/api/v2/superadmin/analytics/visitors/today',

    DAILY_VISITORS:
      '/api/v2/superadmin/analytics/visitors/daily',

    TODAY_GAME_PARTICIPANTS:
      '/api/v2/superadmin/analytics/game-participants/today',
  },
} as const;